import React from "react";
import FooterNext from "../Footers/FooterNext";

export default function PrivacyPolicy() {
  return (
    <div>
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy – Dr Planete</h1>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            1. What information does Dr Planete collect from you?
          </h2>

          <p>
            To deliver exclusive services and a seamless experience, Dr Planete
            collects certain personal information from its members. This
            information is provided directly by you when you purchase a
            membership or engage with the platform, and may also be collected
            automatically through your use of the platform.
          </p>

          <h3 style={{ fontWeight: "bold", color: "#ff007f" }}>
            1. Information you provide directly
          </h3>

          <p>
            When you purchase a Dr Planete membership as a Doctor, Medical
            Student, or Hospital, you may be asked to provide:
          </p>

          <ul>
            <li>
              <strong>For Doctors:</strong> Full Name, Mobile Number, Email ID,
              Date of Birth, Medical Registration Number, Specialization, City
              and State
            </li>

            <li>
              <strong>For Medical Students:</strong> Full Name, Mobile Number,
              Specialization currently pursuing, Name of College, City and
              State
            </li>

            <li>
              <strong>For Hospitals:</strong> Hospital Name, Hospital Phone
              Number, City and State, Name &amp; Designation of Hospital
              Representative, Hospital Registration Number (optional)
            </li>
          </ul>

          <p>
            <em>
              Note: Dr Planete currently does not require document uploads for
              verification, but reserves the right to request additional
              details in the future.
            </em>
          </p>

          <h3 style={{ fontWeight: "bold", color: "#ff007f" }}>
            2. Information collected automatically
          </h3>

          <p>
            We may collect certain technical and usage information through the
            platform and third-party services, including:
          </p>

          <ul>
            <li>Device type and its operating system</li>
            <li>IP address and location (approximate)</li>
            <li>Pages and features visited</li>
            <li>Login dates and activity logs</li>
            <li>App usage and interaction information</li>
            <li>Crash reports and error diagnostics</li>
          </ul>

          <p>
            Such information may be used to understand usage patterns, monitor
            application performance, diagnose technical issues, and improve the
            functionality, reliability, and user experience of our services.
          </p>

          <h3 style={{ fontWeight: "bold", color: "#ff007f" }}>
            3. Information from third parties
          </h3>

          <p>
            Depending on the services or sign-in methods you use, we may
            receive certain information from third-party services, such as:
          </p>

          <ul>
            <li>Name</li>
            <li>Email Address</li>
            <li>Profile Picture</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            2. How we use information we collect?
          </h2>

          <ul>
            <li>
              We use the information submitted by you to provide the Service.
            </li>

            <li>Manage your account and membership.</li>

            <li>Provide you with customer support.</li>

            <li>
              Analyze usage and performance data to improve the functionality,
              reliability, and user experience of our services.
            </li>

            <li>
              Communicate with you via email or phone about services,
              promotions, or offers.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            3. With whom do we share your information?
          </h2>

          <ul>
            <li>
              <strong>With other users:</strong> The information shared by you
              may be published and visible to other users.
            </li>

            <li>
              <strong>With our service providers and partners:</strong> We may
              share relevant information with trusted third-party service
              providers that assist us in providing, maintaining, securing,
              and improving our services, including payment processing and
              other operational services, subject to applicable confidentiality,
              privacy, and security requirements.
            </li>

            <li>
              <strong>With law enforcement agencies:</strong> Disclosed when
              required by law or necessary to protect rights or safety.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            4. How we secure your information?
          </h2>

          <p>
            We implement safeguards designed to protect your information.
            Payments for Dr Planete memberships are processed through
            third-party payment service providers. Dr Planete does not store or
            retain users' full credit/debit card numbers, CVV, PIN, or other
            complete payment credentials on its own systems.
          </p>

          <p>
            Access to personal information maintained by Dr Planete is
            restricted to authorized personnel only.
          </p>

          <p>
            If you have any questions about security, contact us at{" "}
            <a href="mailto:info@drplanete.com">info@drplanete.com</a>
          </p>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            5. Cookies and other tracking tools
          </h2>

          <p>
            We and our third-party partners use cookies, web beacons, and other
            technologies to identify you and analyze user behavior.
          </p>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            6. How we transfer information we collect internationally?
          </h2>

          <p>
            We collect information globally and primarily store that
            information in India and USA. Your information may be transferred,
            processed, and stored outside your country of residence.
          </p>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            7. Data retention
          </h2>

          <p>
            We retain your personal information for as long as necessary to
            provide our services, maintain your account and membership,
            provide customer support, comply with applicable legal and
            regulatory obligations, resolve disputes, prevent fraud or misuse,
            enforce our agreements, and maintain necessary business and
            transaction records.
          </p>

          <p>
            When personal information is no longer required for these purposes,
            we will delete or anonymize it, subject to applicable legal and
            regulatory requirements.
          </p>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            8. Data deletion
          </h2>

          <p>
            You may request deletion of your Dr Planete account and associated
            personal information by contacting us at{" "}
            <a href="mailto:info@drplanete.com">info@drplanete.com</a>.
          </p>

          <p>
            To submit a deletion request, please provide your registered mobile
            number or email address and clearly state that you wish to delete
            your Dr Planete account and associated personal data.
          </p>

          <p>
            Upon receiving a valid request, we will process the request within
            5-7 working days, subject to applicable legal and regulatory
            requirements.
          </p>

          <p>
            Certain information may be retained where necessary to comply with
            legal obligations, prevent fraud or misuse, resolve disputes,
            enforce agreements, or maintain legally required business,
            financial, or transaction records. Such information will be
            retained only for the period required for the applicable purpose.
          </p>

          <p>
            Deletion of your account will result in loss of access to Dr Planete
            services, memberships, benefits, records, or other account-related
            features.
          </p>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            9. How will I know of changes in Dr Planete’s privacy policy?
          </h2>

          <p>
            Updates to this policy will be posted on our website. Continued use
            after changes means acceptance of the new policy.
          </p>
        </section>

        <section className="privacy-section">
          <h2 style={{ fontWeight: "bold", color: "#ff007f" }}>
            10. Tell me how to contact Dr Planete
          </h2>

          <p>
            If you have any questions about this privacy policy or wish to
            submit a data deletion request, contact us at{" "}
            <a href="mailto:info@drplanete.com">info@drplanete.com</a>
          </p>
        </section>

        <style>
          {`
            .privacy-container {
              background-color: #000;
              color: #fff;
              padding: 2rem;
              font-family: Arial, sans-serif;
              line-height: 1.6;
            }

            .privacy-title {
              font-size: 2rem;
              margin-bottom: 1.5rem;
              text-align: center;
            }

            .privacy-section {
              margin-bottom: 2rem;
            }

            .privacy-section h2 {
              font-size: 1.5rem;
              margin-bottom: 1rem;
            }

            .privacy-section h3 {
              font-size: 1.2rem;
              margin-top: 1rem;
              margin-bottom: 0.5rem;
            }

            ul {
              padding-left: 1.5rem;
            }

            a {
              color: #1e90ff;
              text-decoration: underline;
            }

            @media screen and (max-width: 768px) {
              .privacy-container {
                padding: 1rem;
              }

              .privacy-title {
                font-size: 1.5rem;
              }

              .privacy-section h2 {
                font-size: 1.2rem;
              }

              .privacy-section h3 {
                font-size: 1rem;
              }
            }
          `}
        </style>
      </div>

      <FooterNext />
    </div>
  );
}
/*
export default function PrivacyPolicy() {
  return (
    <div>
    <div className="privacy-container">
      <h1 className="privacy-title">Privacy Policy – Dr Planete</h1>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>1. What information does Dr Planete collect from you?</h2>
        <p>
          To deliver exclusive services and a seamless experience, Dr Planete collects certain personal
          information from its members. This information is provided directly by you when you apply for
          membership or engage with the platform, and also indirectly through your usage patterns.
        </p>
        <h3 style={{fontWeight:"bold", color:"#ff007f"}}>1. Information you provide directly</h3>
        <p>When you sign up for Dr Planete as a Doctor, Medical Student, or Hospital, you may be asked to provide:</p>
        <ul>
          <li><strong>For Doctors:</strong> Full Name, Mobile Number, Email ID, Date of Birth, Medical Registration Number, Specialization, City and State</li>
          <li><strong>For Medical Students:</strong> Full Name, Mobile Number, Specialization currently pursuing, Name of College, City and State</li>
          <li><strong>For Hospitals:</strong> Hospital Name, Hospital Phone Number, City and State, Name & Designation of Hospital Representative, Hospital Registration Number (optional)</li>
        </ul>
        <p><em>Note: Dr Planete currently does not require document uploads for verification, but reserves the right to request additional details in the future.</em></p>

        <h3 style={{fontWeight:"bold", color:"#ff007f"}}>2. Information collected automatically</h3>
        <ul>
          <li>Device type and its operating system</li>
          <li>IP address and location (approximate)</li>
          <li>Pages and features visited</li>
          <li>Login dates and activity logs</li>
          <li>Crash reports and error diagnostics</li>
        </ul>

        <h3 style={{fontWeight:"bold", color:"#ff007f"}}>3. Information from third parties</h3>
        <ul>
          <li>Name</li>
          <li>Email Address</li>
          <li>Profile Picture</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>2. How we use information we collect?</h2>
        <ul>
          <li>We use the information submitted by you to provide the Service.</li>
          <li>Manage your account.</li>
          <li>Provide you with customer support.</li>
          <li>Conduct research and analysis for better services using AI and ML.</li>
          <li>Communicate with you via email or phone about services, promotions, or offers.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>3. With whom do we share your information?</h2>
        <ul>
          <li><strong>With other users:</strong> The information shared by you may be published and visible to other users.</li>
          <li><strong>With our service providers and partners:</strong> We may share data with trusted third-party providers under strict confidentiality.</li>
          <li><strong>With law enforcement agencies:</strong> Disclosed when required by law or necessary to protect rights or safety.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>4. How we secure your information?</h2>
        <p>
          We implement safeguards designed to protect your information. Sensitive data like credit card numbers is encrypted.
          Access to personal information is restricted to authorized personnel only.
        </p>
        <p>
          If you have any questions about security, contact us at <a href="mailto:info@drplanete.com">info@drplanete.com</a>
        </p>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>5. Cookies and other tracking tools</h2>
        <p>
          We and our third-party partners use cookies, web beacons, and other technologies to identify you and analyze user behavior.
        </p>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>6. How we transfer information we collect internationally?</h2>
        <p>
          We collect information globally and primarily store that information in India and USA. Your information may be transferred,
          processed, and stored outside your country of residence.
        </p>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>7. How will I know of changes in Dr Planete’s privacy policy?</h2>
        <p>
          Updates to this policy will be posted on our website. Continued use after changes means acceptance of the new policy.
        </p>
      </section>

      <section className="privacy-section">
        <h2 style={{fontWeight:"bold", color:"#ff007f"}}>8. Tell me how to contact Dr Planete</h2>
        <p>
          If you have any questions about this privacy policy, contact us at <a href="mailto:info@drplanete.com">info@drplanete.com</a>
        </p>
      </section>

      <style>
        {`
          .privacy-container {
            background-color: #000;
            color: #fff;
            padding: 2rem;
            font-family: Arial, sans-serif;
            line-height: 1.6;
          }

          .privacy-title {
            font-size: 2rem;
            margin-bottom: 1.5rem;
            text-align: center;
          }

          .privacy-section {
            margin-bottom: 2rem;
          }

          .privacy-section h2 {
            font-size: 1.5rem;
            margin-bottom: 1rem;
          }

          .privacy-section h3 {
            font-size: 1.2rem;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
          }

          ul {
            padding-left: 1.5rem;
          }

          a {
            color: #1e90ff;
            text-decoration: underline;
          }

          @media screen and (max-width: 768px) {
            .privacy-container {
              padding: 1rem;
            }

            .privacy-title {
              font-size: 1.5rem;
            }

            .privacy-section h2 {
              font-size: 1.2rem;
            }

            .privacy-section h3 {
              font-size: 1rem;
            }
          }
        `}
      </style>
    </div>

    <FooterNext/>
    </div>
  );
}
*/

/*const PrivacyPolicy = () => {
  return (
    <div style={{ background: "black" }}>
      <center><h1 style={{ color: "white" }}>PRIVACY POLICY</h1></center>
 
 
      <center><h3 style={{ color: "white" }}>Introduction</h3></center>	
 
<div style={{ color: "white" }}>Welcome to Dr Planete
 
 Dr Planete (Sungowin Technologies Pvt. Ltd.) (“us”, “we”, or “our”) operates www.drplanete.com and Dr Planete mobile application (hereinafter referred to as “Service”).
  
 Our Privacy Policy governs your visit to www.drplanete.com and Dr Planete mobile application, and explains how we collect, safeguard and disclose information that results from your use of our Service. 
  
 We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
  
 Our Terms and Conditions (“Terms”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“agreement”).</div>
 
<center><h3 style={{ color: "white" }}>Definitions</h3></center>	
 
<div style={{ color: "white" }}>SERVICE means the Dr Planete mobile application operated by Dr Planete<div>PERSONAL DATA means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</div>
 
 <div style={{ color: "white" }}>USAGE DATA is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).</div>
  
 <div style={{ color: "white" }}>COOKIES are small files stored on your device (computer or mobile device).</div></div>
 

 
<div style={{ color: "white" }}>DATA CONTROLLER means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.DATA PROCESSORS (OR SERVICE PROVIDERS) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.
 
 DATA SUBJECT is any living individual who is the subject of Personal Data.
  
 THE USER is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.</div>
 

 
<div><h3 style={{ color: "white" }}>Information Collection and Use</h3>
 
 <div style={{ color: "white" }}>
 We collect several different types of information for various purposes to provide and improve our Service to you.
 
4.	Types of Data Collected
 
Personal Data
While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to:
 
a)	Full Name
b)	Date of Birth
c)	Gender
d)	Phone Number
e)	Email Address
f)	Specialization Details
g)	Govt valid Identity proof
h)	City and State of Residence
i)	Staff Details
 
We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by emailing at info@drlite.in.
 
Usage Data
We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device (“Usage Data”).
 
This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
 
When you access Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
 
Tracking Cookies Data
We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.
 
Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.
 
You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
 
Examples of Cookies we use:
 
(a)	Session Cookies: We use Session Cookies to operate our Service.
 
(b)	Preference Cookies: We use Preference Cookies to remember your preferences and various settings.
 
(c)	Security Cookies: We use Security Cookies for security purposes.
 
(d)	Advertising Cookies: Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.
 
Other Data
While using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship, registration at place of residence and actual address, telephone number (work, mobile), details of documents on education, qualification, professional training, employment agreements, non-disclosure agreements, information on bonuses and compensation, information on marital status, family members, social security (or other taxpayer identification) number, office location and other data. 
 
5.	Use of Data
 
Dr Planete uses the collected data for various purposes:
 
(a)	to provide and maintain our Service;
 
(b)	to notify you about changes to our Service; 
 
(c)	to allow you to participate in interactive features of our Service when you choose to do so; 
 
(d)	to provide customer support; 
 
(e)	to gather analysis or valuable information so that we can improve our Service; 
 
(f)	to monitor the usage of our Service;
 
(g)	to detect, prevent and address technical issues;
 
(h)	to fulfill any other purpose for which you provide it;
 
(i)	to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;
 
(j)	to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;
 
(k)	to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;
 
(l)	in any other way we may describe when you provide the information;
 
(m)	for any other purpose with your consent. 
 
6.	Retention of Data
 
We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
 
We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.
 
7.	Transfer of Data
 
Your information, including Personal Data, may be transferred to – and maintained on – computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
 
If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.
 
Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
 
Dr Planete will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.
 
8.	Disclosure of Data
 
We may disclose personal information that we collect, or you provide:
 
(a)	Disclosure for Law Enforcement.
Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.
 
(b)	Other cases. We may disclose your information also:
 
(i)	to our subsidiaries and affiliates;
 
9.	Security of Data
 
The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
 
10.	Your Data Protection Rights Under General Data Protection Regulation (GDPR)
 
If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR. – See more at https://eur-lex.europa.eu/eli/reg/2016/679/oj 
 
We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.
 
If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at info@drlite.in. 
 
In certain circumstances, you have the following data protection rights:
 
(a)	the right to access, update or to delete the information we have on you;
 
(b)	the right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete;
 
(c)	the right to object. You have the right to object to our processing of your Personal Data;
 
(d)	the right of restriction. You have the right to request that we restrict the processing of your personal information;
 
(e)	the right to data portability. You have the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format;
 
(f)	the right to withdraw consent. You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information;
 
Please note that we may ask you to verify your identity before responding to such requests. Please note, we may not able to provide Service without some necessary data.
 
You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).
 
11.	Service Providers
 
We may employ third party companies and individuals to facilitate our Service (“Service Providers”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.
 
These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
 
12.	Analytics
 
We may use third-party Service Providers to monitor and analyze the use of our Service.
 
Google Analytics
Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network.
 
For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: https://policies.google.com/privacy?hl=en
 
We also encourage you to review the Google's policy for safeguarding your data: https://support.google.com/analytics/answer/6004245.
 
Firebase
Firebase is analytics service provided by Google Inc.
 
You may opt-out of certain Firebase features through your mobile device settings, such as your device advertising settings or by following the instructions provided by Google in their Privacy Policy: https://policies.google.com/privacy?hl=en
 
For more information on what type of information Firebase collects, please visit the Google Privacy Terms web page: https://policies.google.com/privacy?hl=en
 
 
13.	Advertising
 
We may use third-party Service Providers to show advertisements to you to help support and maintain our Service.
 
Google AdSense DoubleClick Cookie
Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet.
 
You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: http://www.google.com/ads/preferences/
 
AdMob by Google
AdMob by Google is provided by Google Inc.
 
You can opt-out from the AdMob by Google service by following the instructions described by Google: https://support.google.com/ads/answer/2662922?hl=en
 
For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners' sites or app” page: http://www.google.com/policies/privacy/partners/ or visit the Privacy Policy of Google: http://www.google.com/policies/privacy/
 
14.	Behavioral Remarketing
 
Dr Planete uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.
 
Google Ads (AdWords)
Google Ads (AdWords) remarketing service is provided by Google Inc.
 
You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: http://www.google.com/settings/ads
 
Google also recommends installing the Google Analytics Opt-out Browser Add-on – https://tools.google.com/dlpage/gaoptout – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.
 
For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: https://policies.google.com/privacy?hl=en
 
Facebook
Facebook remarketing service is provided by Facebook Inc.
 
You can learn more about interest-based advertising from Facebook by visiting this page: https://www.facebook.com/help/164968693837950
 
To opt-out from Facebook's interest-based ads, follow these instructions from Facebook: https://www.facebook.com/help/568137493302217
 
Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA http://www.aboutads.info/choices/, the Digital Advertising Alliance of Canada in Canada http://youradchoices.ca/ or the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt-out using your mobile device settings.
 
For more information on the privacy practices of Facebook, please visit Facebook's Data Policy: https://www.facebook.com/privacy/explanation
 
15.	Payments
 
We may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).
 
We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
 
The payment processors we work with are:
 
PayPal or Braintree:
Their Privacy Policy can be viewed at https://www.paypal.com/webapps/mpp/ua/privacy-full
 
16.	Links to Other Sites
 
Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
 
We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
 
17.	Children's Privacy
 
Our Services are not intended for use by children under the age of 18 (“Child” or “Children”). 
 
We do not knowingly collect personally identifiable information from Children under 18. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.
 
18.	Changes to This Privacy Policy
 
We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
 
We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.
 
You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
 
19.	Contact Us
 
If you have any questions about this Privacy Policy, please contact us:
 
By email: info@drplanete.com

</div>
</div>
<div>
  <FooterNext/>
</div>
    </div>
  );
};

export default PrivacyPolicy;

*/